import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class ApidataService {
 localUrl = 'https://drasfarsurgeon.com/hospitaladmin/api/';
 constructor(private httpClient: HttpClient) {
 }

 login(email: string, password: string): Observable<any> {

  const body = { email, password };
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  return this.httpClient.post(this.localUrl + 'login', body, { headers });
}
UpdateJob(agency: FormData, id): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.post<any>(this.localUrl + 'jobs/update/' + id, agency,headerOptions);
}
JobPost(JobPost: FormData): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.post<any>( this.localUrl +'jobpost', JobPost,headerOptions);
}
Jobsbyid(jobid): Observable<any> { // Update the return type
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.get<any>(this.localUrl + 'jobs/view/' +jobid);
}
searchJobs(params: any): Observable<any> {
  let queryParams = new HttpParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      queryParams = queryParams.append(key, params[key]);
    }
  }

  return this.httpClient.get<any>(`${this.localUrl}jobsearch`, { params: queryParams });
}

Resumeupload(Resumeupload: FormData): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.post<any>(this.localUrl +'CandidateResume/add', Resumeupload);
}
JobsDelete(jobid): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.get<any>(this.localUrl +'jobs/delete/' + jobid,headerOptions);
}
contactDelete(contactid): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.get<any>(this.localUrl +'contacts/delete/' + contactid, headerOptions);
}

Allcontacts(): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.get<any>(this.localUrl +'contacts/getall',headerOptions);
}
appliedcandidate(): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  };     return this.httpClient.get<any>(this.localUrl +'CandidateResume/getall',headerOptions);
}
Contactinsert(Contactinsert: FormData): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.post<any>(this.localUrl +'contact/add', Contactinsert,headerOptions);
  
}
CandidateResumeDelete(id): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.get<any>(this.localUrl +'CandidateResume/delete/' + id,headerOptions);
}
servicesgetall(): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  };     return this.httpClient.get<any>(this.localUrl +'Services/Getall',headerOptions);
}

updateServiceStatus(serviceuid: string, data: any): Observable<any> {
  return this.httpClient.put(`${this.localUrl}services/${serviceuid}/status`, data);

  // return this.httpClient.put(`services/${serviceuid}/status`, data);
}


Servicepost(Servicepost: FormData): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.post<any>( this.localUrl +'Services/Addservice', Servicepost,headerOptions);
}
servicesDelete(Serviceid): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.get<any>(this.localUrl +'Services/delete/' + Serviceid, headerOptions);
}
servicesbyid(serviceuid): Observable<any> { // Update the return type
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.get<any>(this.localUrl + 'Services/view/' +serviceuid,headerOptions);
}
Updateservice(agency: FormData, serviceuid): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.post<any>(this.localUrl + 'Services/update/' + serviceuid, agency,headerOptions);
}
navbargetall(): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  };     return this.httpClient.get<any>(this.localUrl +'Services/navbarGetall',headerOptions);
}
servicesbyurl(servicesUrl): Observable<any> { // Update the return type
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.get<any>(this.localUrl + 'Services/navbarview/' +servicesUrl);
}
Emailconfig(): Observable<any> {
  const headerOptions = {
    headers: new HttpHeaders
      ({ 'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') })
  };
  return this.httpClient.get<any>(this.localUrl + 'mail/get-mail-config', headerOptions);
}
Emailconfiguration(Service: FormData): Observable<any> {
  const headerOptions = {
    headers: new HttpHeaders
      ({ 'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') })
  };
  return this.httpClient.post<any>(this.localUrl + 'update-mail-config', Service, headerOptions);
}
clientimages(files: FormData): Observable<any> {
  const headerOptions = {
    headers: new HttpHeaders
      ({ 'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') })
  };
  return this.httpClient.post<any>(this.localUrl + 'upload-client-images', files,headerOptions);
}
clientimagesgetall(): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  };     return this.httpClient.get<any>(this.localUrl +'client/Images',headerOptions);
}
clientimageDelete(clientid): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.get<any>(this.localUrl +'client/imagedelete/' + clientid, headerOptions);
}
// /Services/Getall
// https://drasfarsurgeon.com/hospitaladmin/api/Services/navbarview/Services_Url








 AppointmentForm(AppointmentForm: FormData): Observable<any> {
   return this.httpClient.post<any>( this.localUrl +'jobpost.php', AppointmentForm);
 }
  Alljobs(): Observable<any> {
    const headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.httpClient.get<any>(this.localUrl + 'jobs/getall');
  }
  // Navbar
  Navbarcontent(): Observable<any> {
    const headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.httpClient.get<any>(this.localUrl +'Coursesnavbar.php');
  }
  Getservicebyid(servicesUrl): Observable<any> {
    return this.httpClient.get<any>(this.localUrl +'servicesgetbyurl.php?servicesUrl=%22' + servicesUrl + '%22');
  }
 
   Getserviceb(idservices): Observable<any> {
    return this.httpClient.get<any>(this.localUrl +'servicesgetbyid.php?idservices=' + idservices );
  }
  JobGetbyID(idjobs): Observable<any> {
    return this.httpClient.get<any>(this.localUrl +'getjobsbyid.php?idjobs=' + idjobs);
  }
  ServiceForm(Service: FormData): Observable<any> {
    return this.httpClient.post<any>(this.localUrl +'ServicePost.php', Service);
  }
  updateServiceForm(Service: FormData): Observable<any> {
    return this.httpClient.post<any>(this.localUrl +'updateservices.php', Service);
  }
 
ServicesDelete(idservices): Observable<any> {
  return this.httpClient.get<any>(this.localUrl +'deleteservices.php?idservices=' + idservices);
}


Login(LoginForm: FormData): Observable<any> {
  const headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  return this.httpClient.post<any>(this.localUrl + 'login', LoginForm);
}

  successSwalnew(any: any, doc: any) {
    Swal.fire(any, doc, 'success');
  }

  DangerSwalnew(any: any, doc: any) {
    Swal.fire(any, doc, 'error');
  }

  metagetall(): Observable<any> {
    const headerOptions = { headers: new HttpHeaders
      ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
    };     return this.httpClient.get<any>(this.localUrl +'metadatagetall',headerOptions);
  }

  metaDelete(id): Observable<any> {
    const headerOptions = { headers: new HttpHeaders
      ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
    }; 
    return this.httpClient.delete<any>(this.localUrl +'metadata/' + id, headerOptions);
  }


  uploadFiles(files: File[], imageNames: string[]): Observable<any> {
    const formData: FormData = new FormData();
    files.forEach((file, index) => {
      formData.append('actorimages[]', file, file.name);
      formData.append('image_name[]', imageNames[index]);
    });
  
    return this.httpClient.post(this.localUrl + 'upload-gallery', formData, {
      headers: new HttpHeaders({
        'Accept': 'application/json'
      })
    });
  }
  
multipleGalleryimages(files: FormData): Observable<any> {
  const headerOptions = {
    headers: new HttpHeaders
      ({ 'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') })
  };
  return this.httpClient.post<any>(this.localUrl + 'upload-gallery', files,headerOptions);
}

Galleryimagesgetall(): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  };     return this.httpClient.get<any>(this.localUrl +'gallery/Images',headerOptions);
}
GalleryimageDelete(galleryid: any): Observable<any> {
  const headerOptions = { headers: new HttpHeaders
    ({'Authorization': 'Bearer' + ' ' + localStorage.getItem('Token') } )
  }; 
  return this.httpClient.get<any>(this.localUrl +'gallery/imagedelete/' + galleryid, headerOptions);
}
}
